import echarts from "echarts";
//文字换行
function formatter(params) {
  var newParamsName = ""; // 最终拼接成的字符串
  var paramsNameNumber = params.length; // 实际标签的个数
  var provideNumber = 5; // 每行能显示的字的个数
  var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
  /**
   * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
   */
  // 条件等同于rowNumber>1
  if (paramsNameNumber > provideNumber) {
    /** 循环每一行,p表示行 */
    for (var p = 0; p < rowNumber; p++) {
      var tempStr = ""; // 表示每一次截取的字符串
      var start = p * provideNumber; // 开始截取的位置
      var end = start + provideNumber; // 结束截取的位置
      // 此处特殊处理最后一行的索引值
      if (p == rowNumber - 1) {
        // 最后一次不换行
        tempStr = params.substring(start, paramsNameNumber);
      } else {
        // 每一次拼接字符串并换行
        tempStr = params.substring(start, end) + "\n";
      }
      newParamsName += tempStr; // 最终拼成的字符串
    }
  } else {
    // 将旧标签的值赋给新标签
    newParamsName = params;
  }
  //将最终的字符串返回
  return newParamsName;
}
function deepClone(array) {
  let _array = JSON.stringify(array);
  return JSON.parse(_array);
}
//健康值趋势计算图
export function echart1(dom, hcalcarr) {
  var dataname = [];
  var data = [];
  var dataend = [];
  var list = deepClone(hcalcarr);

  if (list.length < 7) {
    data.push(list[0].hValue, list[0].predictHValue);
    var option = {
      title: {
        text: "健康值",
        left: "40",
        textStyle: {
          color: "#666",
          fontSize: 13,
          lineHeight: 56,
        },
      },
      xAxis: {
        type: "category",
        data: ["当前", "预测值"],
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        axisLabel: {
          color: function (value) {
            return value == "当前" ? "#0077F9" : "#33C5FF ";
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 1000,
        interval: 100,
        axisLabel: {
          color: "#666",
        },
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        splitLine: {
          lineStyle: {
            color: "#F7F7F7",
            //type:'dashed'虚线
          },
        },
      },

      tooltip: {
        trigger: "axis",
        // axisPointer: {
        //   type: 'cross',
        //   label: {
        //     backgroundColor: '#6a7985'
        //   }
        // }
      },
      series: [
        {
          data: data,
          type: "line",
          symbol: "emptyCircle",
          symbolSize: 16,
          smooth: true,
          itemStyle: {
            normal: {
              // label : {show: true},
              color: function (value) {
                return value.name == "当前" ? "#0077F9" : "#87CFF7 ";
              },
              lineStyle: {
                width: 3,
                type: "solid",
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0077F9",
                  },
                  {
                    offset: 1,
                    color: "#87CFF7",
                  },
                ]), //线条渐变色
              },
            },
          },
        },
      ],
    };
    dom.setOption(option);
  } else {
    if (list[0].day) {
      list.forEach((v, i) => {
        v.name = "";
        v.size = 0;
        v.issymbol = false;
        list[0].name = "当前";
        list[list.length - 1].name = "预测值";
        list[0].size = "16";
        list[list.length - 1].size = "16";
        list[0].issymbol = true;
        list[list.length - 1].issymbol = true;
        data.push(v.predictHValue);
        dataname.push(v.name);
        dataend.push("");
      });
    }
    data[0] = list[0].hValue;
    dataend[dataend.length - 1] = data[data.length - 1];

    var option = {
      title: {
        text: "健康值",
        left: "40",
        textStyle: {
          color: "#666",
          fontSize: 13,
          lineHeight: 56,
        },
      },
      xAxis: {
        type: "category",
        data: dataname,
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        axisLabel: {
          color: function (value) {
            return value == "当前" ? "#0077F9" : "#33C5FF ";
          },
          interval: 0,
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        // max: 1000,
        interval: 100,
        axisLabel: {
          color: "#666",
        },
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        splitLine: {
          lineStyle: {
            color: "#F7F7F7",
            //type:'dashed'虚线
          },
        },
      },

      tooltip: {
        // trigger: 'axis',
        // axisPointer: {
        //   type: 'cross',
        //   label: {
        //     backgroundColor: '#6a7985'
        //   }
        // }
      },
      series: [
        {
          //第一个折点
          data: [data[0]],
          type: "line",
          symbol: "emptyCircle",
          symbolSize: 16,
          smooth: true,
          itemStyle: {
            normal: {
              color: function (value) {
                return value.name == "当前" ? "#0077F9" : "#87CFF7";
              },
            },
          },
        },
        {
          //最后一个折点
          data: dataend,
          type: "line",
          symbol: "emptyCircle",
          // symbolSize: function (val) {
          //   if (val > 0) {
          //     return 16
          //   }
          // },
          symbolSize: 16,
          smooth: true,
          itemStyle: {
            normal: {
              color: function (value) {
                return value.name == "当前" ? "#0077F9" : "#87CFF7 ";
              },
              // lineStyle: {
              //   opacity: 0
              // }
            },
          },
        },
        {
          //所有的数据连在一起
          data: data,
          type: "line",
          symbol: "emptyCircle",
          symbolSize: 0,
          smooth: true,
          itemStyle: {
            normal: {
              color: function (value) {
                return value.name == "当前" ? "#0077F9" : "#87CFF7 ";
              },
              lineStyle: {
                width: 3,
                type: "solid",
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0077F9",
                  },
                  {
                    offset: 1,
                    color: "#87CFF7",
                  },
                ]), //线条渐变色
              },
            },
          },
        },
      ],
    };
    dom.setOption(option);
  }
}

//12种疾病
export function echart2(dom, diseaseGrades, data) {
  let option = {
    color: ["#0062FF", "#D7DBEC", "#7CE7AC", "#5E81F4"],
    // legend: {
    //   right: "20",
    //   top: "20",
    //   data: ["用户当前风险", "一般成年人风险"],
    // },
    grid: {
      // top: '10%',
      left: "-3%",
      right: "5%",
      bottom: "5%",
      containLabel: true,
    },
    xAxis: [
      {
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        axisTick: {
          show: false,
        },
        // //网格样式
        // splitLine: {
        //     show: true,
        //     lineStyle:{
        //         color: ['#F7F7F7'],
        //         width: 1,
        //         type: 'solid'
        //     }
        // },
        axisLabel: {
          color: "#3B4859",
          fontSize: 12,
          rotate: 45,
        },
        type: "category",
        data: data[0],
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        nameTextStyle: {
          color: "#666",
          fontSize: 13,
        },
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        axisTick: {
          show: false,
        },
        //网格样式
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#F7F7F7"],
            width: 1,
            type: "solid",
          },
        },
        type: "value",
        name: "异常指标个数",
        min: 0,
        max: 250,
        interval: 50,
        axisLabel: {
          color: "#666",
          fontSize: 16,
          // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
          formatter: function (value, index) {
            return diseaseGrades[index];
          },
        },
      },
    ],
    series: [
      {
        // name: "用户当前风险",
        type: "bar",
        barWidth: 8,
        data: data[1],
      },
      {
        // name: "一般成年人风险",
        type: "bar",
        barWidth: 8,
        data: data[2],
      },
      // {
      //   // name: "用户当前风险",
      //   type: "line",
      //   barWidth: 8,
      //   data: data[1],
      // },
      // {
      //   // name: "一般成年人风险",
      //   type: "line",
      //   barWidth: 8,
      //   data: data[2],
      // },
      // {
      //     name: '发病概率',
      //     type: 'line',
      //     lineStyle: {
      //       width: 1,
      //     },
      //     data: [22.0, 22.2, 32.3, 42.5, 62.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 26.2]
      // },
      // {
      //     name: '发病倍数',
      //     type: 'line',
      //     lineStyle: {
      //       width: 1,
      //     },
      //     data: [33.0, 33.2, 34.3, 35.5, 37.3, 31.2, 31.3, 34.4, 34.0, 37.5, 33.0, 37.2]
      // }
    ],
  };
  dom.setOption(option);
}

//健康年龄
export function echart3(dom, data) {
  let option = {
    grid: {
      // top: '2%',
      left: "2%",
      right: "2%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: [
      {
        axisLine: {
          show: false,
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#3B4859",
          fontSize: 12,
          // rotate: 45,
        },
        type: "category",
        data: data[0],
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        show: false,
      },
    ],
    series: [
      {
        data: [
          {
            value: 200,
            itemStyle: {
              color: "#7CE7AC",
            },
          },
          {
            value: 100,
            itemStyle: {
              color: "#5E81F4",
            },
          },
        ],
        type: "bar",
        showBackground: true,
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#3B4859",
              },
            },
          },
        },
        barWidth: 24, //柱图宽度
        // backgroundStyle: {
        //     color: 'rgba(180, 180, 180, 0.2)'
        // }
      },
    ],
  };
  dom.setOption(option);
}

//健康评估健康值------历史健康值趋势
export function h_trend_history(dom, xAxisData, echartData) {
  console.log(1, echartData);
  let option = {
    color: ["#E7E7E7", "#78B1F2", "#41CED4", "#78B1F2"],
    // legend:
    //     right : '20',
    //     top : '20',
    //     data: [{
    //         name:'摒弃风险因素后健康趋势预测',
    //         icon: 'roundRect',
    //        }, {
    //         name:'保持现状下健康趋势预测',
    //         icon: 'roundRect',
    //        }
    //     ]
    // },
    grid: {
      left: "2%",
      right: "2%",
      bottom: "2%",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        //去掉移动的指示线
        type: "none",
      },
      formatter: function (echartData, ticket, callback) {
        let showHtm = "";
        for (var i = 0; i < echartData.length; i++) {
          showHtm =
            echartData[i].axisValue +
            "<br/>" +
            echartData[i].value +
            "   " +
            echartData[i].name;
        }
        return showHtm;
      },
    },
    xAxis: [
      {
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#666",
          fontSize: 14,
        },
        type: "category",
        data: xAxisData,
        axisTick: {
          show: true,
          alignWithLabel: true,
        },
      },
    ],
    yAxis: [
      {
        axisLine: {
          lineStyle: {
            color: "#F7F7F7",
          },
        },
        axisTick: {
          show: false,
        },
        //网格样式
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#F7F7F7"],
            width: 1,
            type: "solid",
          },
        },
        axisLabel: {
          color: "#666",
          fontSize: 16,
        },
        type: "value",
        // name: "健康值",
        min: 0,
        max: 1000,
        interval: 200,
      },
    ],
    series: [
      {
        // name: xAxisData,
        type: "line",
        data: echartData,
        // data: [1.123, 2.345, 3.678],
        symbol: "circle", //折点设定为实心点
        symbolSize: 10, //设定实心点的大小
        itemStyle: {
          normal: {
            color: "rgb(184, 221, 255)", //折点颜色
            lineStyle: {
              color: "rgb(184, 221, 255)", //折线颜色
            },
          },
        },
        label: {
          show: true,
          position: "top",
          fontSize: 12,
          color: "#666",
        },
      },
      // {
      //     name: '总数2',
      //     type: 'line',
      //     data: datalist2
      // },
      // {
      //   name: "摒弃风险因素后健康趋势预测",
      //   type: "scatter",
      //   symbol: "roundRect",
      //   symbolSize: [0.1, 0.1],
      //   label: {
      //     normal: {
      //       show: true,
      //       formatter: "{b}",
      //       color: "#666",
      //       padding: 10,
      //       backgroundColor: "#E7E7E7",
      //       borderRadius: 5,
      //       textStyle: {
      //         fontSize: "12",
      //       },
      //     },
      //   },
      //   itemStyle: {
      //     normal: {
      //       // color: 'transparent',
      //       opacity: 1,
      //     },
      //   },
      //   data: echartData,
      // },
      // {
      //     name: '保持现状下健康趋势预测',
      //     type: 'scatter',
      //     symbol: 'roundRect',
      //     symbolSize: [0.1,0.1],
      //     label: {
      //         normal: {
      //             show: true,
      //             formatter: '{b}',
      //             color: '#fff',
      //             padding: 10,
      //             backgroundColor: '#78B1F2',
      //             borderRadius: 5,
      //             textStyle: {
      //                 fontSize: '12'
      //             }
      //         },
      //     },
      //     itemStyle: {
      //         normal: {
      //             // color: 'transparent',
      //             opacity: 1
      //         }
      //     },
      //     data: datalist2
      // },
    ],
  };
  dom.setOption(option);
}
